import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'

export default function SplashScreen() {
  const history = useHistory()
  const location = useLocation()
  const { isLoadingUserData, isConsentRequired, userData } = useAppUserContext()

  useEffect(() => {
    if (isLoadingUserData) {
      return
    }

    const targetPath = isConsentRequired || !userData?.phoneNumberWithUsernamePrefix ? PATH.TRAFFIC_FINE_CONSENT : PATH.TRAFFIC_FINE_LOOKUP

    history.replace({ pathname: targetPath, search: location.search })
  }, [history, isConsentRequired, isLoadingUserData, location.search, userData?.phoneNumberWithUsernamePrefix])

  return <LoadingScreen open solid />
}
